import React from 'react';
import { Tag, TagRow } from '../../Tag';
import ProfileSection from './ProfileSection';
import '../Profile.css';

export interface GenreTagsSectionProps {
  title?: string;
  genres: string[];
}

export const GenreTagsSection: React.FC<GenreTagsSectionProps> = ({ title = 'Genres', genres }) => {
  if (genres.length === 0) return null;

  return (
    <ProfileSection title={title}>
      <TagRow mode="ribbon">
        {genres.map((genre) => (
          <Tag key={genre}>{genre}</Tag>
        ))}
      </TagRow>
    </ProfileSection>
  );
};

export default GenreTagsSection;
